/**
 * defa.views.ClaimForwardOptionForm
 * The view for deciding yes/no to installing an insurance.
 * @version 1.2.0
 */
import Form     from 'scripts/poppet/form';
import template from 'templates/claimForwardOptionForm.jst.html';

const ClaimForwardOptionForm = Form.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	template: template,
	
	
	// ------------------------------------------------
	// Event handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	/**
	 * Submits the form.
	 * @void
	 */
	submit: function () {
		let value = this.$el.find( ':checked' ).val();
		this.trigger( 'claim:forwardOption', value );
	},
	
} );


export default ClaimForwardOptionForm;